import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import 'material-symbols';
import './index.css';
// Before i18n (below): a `/es/...` URL sets the language and loses its prefix first. See applyLocalePrefix.
import '@/lib/applyLocalePrefix';
// Side-effect import: initialises i18next before anything renders. Without this, `useTranslation`
// falls back to the `defaultValue` at each call site, so the UI silently stays English.
import '@/lib/i18n';
import { RootApp } from './RootApp.tsx';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { wasServerRendered } from '@/ssr/ssrData';
import { installChunkReload } from '@/lib/staleBuild';

// A tab left open across a deploy: a route chunk the new build no longer has reloads the page (staleBuild.ts).
installChunkReload();

const container = document.getElementById('root')!;

const tree = (
    <StrictMode>
        <ErrorBoundary>
            <RootApp />
        </ErrorBoundary>
    </StrictMode>
);

// A document the Node server rendered arrives with markup already in #root and its state in
// `window.__GOZIG_SSR__`; hydrating attaches to that markup instead of throwing it away. Every
// other document (SSR off, a route that is not in the allowlist, a render that fell back) is
// the untouched SPA shell and mounts exactly as it always has.
if (wasServerRendered()) {
    hydrateRoot(container, tree);
}
else {
    createRoot(container).render(tree);
}
